// @flow
import { get, isEqual, sortBy, reject } from 'lodash';
import { ACCOMMODATION_COMFORT_ORDER } from 'Utils/accommodation/accommodation.constants';

function sortAccommodations(
  accommodationsSets: Array<AccommodationsSet>,
): Array<AccommodationsSet> {
  return sortBy(accommodationsSets, set => {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return ACCOMMODATION_COMFORT_ORDER.indexOf(get(set, 'accommodations[0].categoryId'));
  }).map((set, index) => {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return { ...set, accommodationSetNumber: index + 1 };
  });
}

function filterAccommodations(
  proposal: Proposal,
  accommodationsSets: Array<AccommodationsSet>,
): Array<AccommodationsSet> {
  const proposalAccommodations = get(proposal, 'accommodations', []);
  // remove additional accommodation if already exists in selected proposal
  const filteredAccommodations = reject(accommodationsSets, ({ accommodations }) =>
    isEqual(accommodations, proposalAccommodations),
  );
  // sort additional accommodations by comfort level: Standard, Deluxe, Suite
  return sortAccommodations(filteredAccommodations);
}

export { filterAccommodations, sortAccommodations };
